export default __webpack_public_path__ + "static/media/Ballroll_00379.185a5fca.png";